import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Le chiavi sono le stringhe originali in italiano: la versione italiana le
// riutilizza così come sono, quella inglese le mappa sulla traduzione.
// Le chiavi mancanti ricadono sul testo italiano (fallbackLng).
const resources = {
  it: {
    translation: {
      "(si attiverà alla registrazione)": "(si attiverà alla registrazione)",
      "A": "A",
      "Abbiamo inviato un link sicuro all'indirizzo email.": "Abbiamo inviato un link sicuro all'indirizzo email.",
      "Accedi": "Accedi",
      "Accedi al tuo account": "Accedi al tuo account",
      "Accedi con Google": "Accedi con Google",
      "Accesso in corso...": "Accesso in corso...",
      "Accetta": "Accetta",
      "Account": "Account",
      "Account eliminato": "Account eliminato",
      "Aggiorna Password": "Aggiorna Password",
      "Aggiorna la password del tuo account": "Aggiorna la password del tuo account",
      "Aggiorna la password del tuo account.": "Aggiorna la password del tuo account.",
      "Aggiungi": "Aggiungi",
      "Aggiungi categoria": "Aggiungi categoria",
      "Aggiungi portafoglio": "Aggiungi portafoglio",
      "Al": "Al",
      "Al:": "Al:",
      "Andamento mensile (spese vs entrate)": "Andamento mensile (spese vs entrate)",
      "Annulla": "Annulla",
      "Azioni irreversibili, richiedono la password": "Azioni irreversibili, richiedono la password",
      "Azioni irreversibili_desc": "Azioni irreversibili, richiedono la password.",
      "Azzera": "Azzera",
      "Azzera filtri": "Azzera filtri",
      "Backup e Ripristino": "Backup e Ripristino",
      "Benvenuto": "Benvenuto",
      "Cambia Password": "Cambia Password",
      "Cambia la lingua dell'applicazione / Change app language": "Cambia la lingua dell'applicazione",
      "Carica file": "Carica file",
      "Carica un file XLSX o CSV. Verranno creati automaticamente portafogli, categorie e transazioni mancanti.": "Carica un file XLSX o CSV. Verranno creati automaticamente portafogli, categorie e transazioni mancanti.",
      "Caricamento categorie...": "Caricamento categorie...",
      "Caricamento portafogli...": "Caricamento portafogli...",
      "Caricamento sessione...": "Caricamento sessione...",
      "Caricamento...": "Caricamento...",
      "Carta di credito": "Carta di credito",
      "Categoria": "Categoria",
      "Categorie": "Categorie",
      "Categorie eliminate": "Categorie eliminate",
      "Categorie per trasferimento non trovate": "Categorie per trasferimento non trovate",
      "Cognome": "Cognome",
      "Cognome deve avere almeno 2 caratteri": "Cognome deve avere almeno 2 caratteri",
      "Cognome è richiesto": "Cognome è richiesto",
      "Compila tutti i campi": "Compila tutti i campi",
      "Conferma Nuova Password": "Conferma Nuova Password",
      "Conferma Password": "Conferma Password",
      "Conferma eliminazione": "Conferma eliminazione",
      "Conferma nuova password": "Conferma nuova password",
      "Conferma password è richiesta": "Conferma password è richiesta",
      "Contanti": "Contanti",
      "Conti": "Conti",
      "Crea il tuo account": "Crea il tuo account",
      "Crea trasferimento": "Crea trasferimento",
      "Crea una password sicura": "Crea una password sicura",
      "Credenziali non valide": "Credenziali non valide",
      "Da": "Da",
      "Dal": "Dal",
      "Dal:": "Dal:",
      "Dashboard": "Dashboard",
      "Descrizione": "Descrizione",
      "Descrizione (opzionale)": "Descrizione (opzionale)",
      "Elimina": "Elimina",
      "Elimina Transazioni": "Elimina Transazioni",
      "Elimina account": "Elimina account",
      "Elimina categoria": "Elimina categoria",
      "Elimina definitivamente account e tutti i dati collegati.": "Elimina definitivamente account e tutti i dati collegati.",
      "Elimina notifica": "Elimina notifica",
      "Elimina portafoglio": "Elimina portafoglio",
      "Elimina transazione": "Elimina transazione",
      "Elimina transazioni": "Elimina transazioni",
      "Elimina tutte le categorie": "Elimina tutte le categorie",
      "Elimina tutte le categorie e le transazioni collegate.": "Elimina tutte le categorie e le transazioni collegate.",
      "Elimina tutte le tue transazioni, oppure solo quelle che corrispondono a filtri specifici.": "Elimina tutte le tue transazioni, oppure solo quelle che corrispondono a filtri specifici.",
      "Elimina tutti i portafogli": "Elimina tutti i portafogli",
      "Elimina tutti i portafogli (escluso Generale) e le transazioni collegate.": "Elimina tutti i portafogli (escluso Generale) e le transazioni collegate.",
      "Eliminazione Dati": "Eliminazione Dati",
      "Eliminazione...": "Eliminazione...",
      "Email": "Email",
      "Email della persona da invitare": "Email della persona da invitare",
      "Email gia' registrata": "Email gia' registrata",
      "Email non trovata": "Email non trovata",
      "Email è richiesta": "Email è richiesta",
      "Entrate": "Entrate",
      "Entrate del mese": "Entrate del mese",
      "Entrate per categoria": "Entrate per categoria",
      "Errore": "Errore",
      "Errore caricamento dati": "Errore caricamento dati",
      "Errore caricamento report": "Errore caricamento report",
      "Errore durante il cambio password": "Errore durante il cambio password",
      "Errore durante il login": "Errore durante il login",
      "Errore durante il trasferimento": "Errore durante il trasferimento",
      "Errore durante l'accesso con Google": "Errore durante l'accesso con Google",
      "Errore durante l'aggiornamento della password. Il link potrebbe essere scaduto.": "Errore durante l'aggiornamento della password. Il link potrebbe essere scaduto.",
      "Errore durante l'aggiunta": "Errore durante l'aggiunta",
      "Errore durante l'eliminazione": "Errore durante l'eliminazione",
      "Errore durante l'export": "Errore durante l'export",
      "Errore durante l'import": "Errore durante l'import",
      "Errore durante l'invito": "Errore durante l'invito",
      "Errore durante la modifica": "Errore durante la modifica",
      "Errore durante la registrazione con Google": "Errore durante la registrazione con Google",
      "Errore durante la registrazione.": "Errore durante la registrazione.",
      "Errore durante la rimozione": "Errore durante la rimozione",
      "Errore modifica": "Errore modifica",
      "Errore nel caricamento dati": "Errore nel caricamento dati",
      "Errore nel caricamento dei portafogli": "Errore nel caricamento dei portafogli",
      "Errore nel caricamento delle categorie": "Errore nel caricamento delle categorie",
      "Errore nel caricamento delle notifiche": "Errore nel caricamento delle notifiche",
      "Errore trasferimento": "Errore trasferimento",
      "Esci": "Esci",
      "Esporta CSV": "Esporta CSV",
      "Esporta dati": "Esporta dati",
      "Esporta il tuo archivio o importa un backup da file": "Esporta il tuo archivio o importa un backup da file",
      "Esporta le tue transazioni in un file CSV (tutte o filtrate), o importa un backup da file XLSX/CSV.": "Esporta le tue transazioni in un file CSV (tutte o filtrate), o importa un backup da file XLSX/CSV.",
      "Esporta transazioni": "Esporta transazioni",
      "Esportazione...": "Esportazione...",
      "Filtra": "Filtra",
      "Filtri": "Filtri",
      "Generale": "Generale",
      "Guadagni": "Guadagni",
      "Guadagno": "Guadagno",
      "Hai già un account?": "Hai già un account?",
      "I tuoi Portafogli": "I tuoi Portafogli",
      "Import completato!": "Import completato!",
      "Importa backup": "Importa backup",
      "Importazione in corso...": "Importazione in corso...",
      "Importo": "Importo",
      "Impossibile inviare l'email di recupero. Riprova più tardi.": "Impossibile inviare l'email di recupero. Riprova più tardi.",
      "Imposta Nuova Password": "Imposta Nuova Password",
      "Impostazioni": "Impostazioni",
      "Inserisci e conferma la tua nuova password.": "Inserisci e conferma la tua nuova password.",
      "Inserisci il tuo cognome": "Inserisci il tuo cognome",
      "Inserisci il tuo nome": "Inserisci il tuo nome",
      "Inserisci l'email del tuo account": "Inserisci l'email del tuo account",
      "Inserisci la password": "Inserisci la password",
      "Inserisci la password per confermare": "Inserisci la password per confermare",
      "Inserisci la tua email": "Inserisci la tua email",
      "Inserisci la tua email. Ti invieremo un link sicuro per reimpostarla.": "Inserisci la tua email. Ti invieremo un link sicuro per reimpostarla.",
      "Inserisci un indirizzo email valido": "Inserisci un indirizzo email valido",
      "Invia Link di Recupero": "Invia Link di Recupero",
      "Invia invito": "Invia invito",
      "Invio in corso...": "Invio in corso...",
      "Invita a": "Invita a",
      "Invito accettato!": "Invito accettato!",
      "Invito creato per": "Invito creato per",
      "Invito inviato a": "Invito inviato a",
      "Invito rifiutato": "Invito rifiutato",
      "La nuova password deve avere almeno 8 caratteri": "La nuova password deve avere almeno 8 caratteri",
      "La password deve avere almeno 8 caratteri": "La password deve avere almeno 8 caratteri",
      "La tua Email": "La tua Email",
      "La tua password è stata aggiornata con successo!": "La tua password è stata aggiornata con successo!",
      "Le password non coincidono": "Le password non coincidono",
      "Le tue Categorie": "Le tue Categorie",
      "Lingua": "Lingua",
      "Login effettuato con successo!": "Login effettuato con successo!",
      "Mese": "Mese",
      "Minimo 8 caratteri": "Minimo 8 caratteri",
      "Modifica": "Modifica",
      "Mostra conferma password": "Mostra conferma password",
      "Mostra password": "Mostra password",
      "Nascondi conferma password": "Nascondi conferma password",
      "Nascondi password": "Nascondi password",
      "Nessun dato": "Nessun dato",
      "Nessun dato per il periodo.": "Nessun dato per il periodo.",
      "Nessun portafoglio": "Nessun portafoglio",
      "Nessun portafoglio creato.": "Nessun portafoglio creato.",
      "Nessuna categoria": "Nessuna categoria",
      "Nessuna categoria creata.": "Nessuna categoria creata.",
      "Nessuna notifica.": "Nessuna notifica.",
      "Nessuna transazione a": "Nessuna transazione a",
      "Nessuna transazione.": "Nessuna transazione.",
      "Nome": "Nome",
      "Nome deve avere almeno 2 caratteri": "Nome deve avere almeno 2 caratteri",
      "Nome è richiesto": "Nome è richiesto",
      "Non hai un account?": "Non hai un account?",
      "Notifiche": "Notifiche",
      "Nuova Password": "Nuova Password",
      "Nuova Transazione": "Nuova Transazione",
      "Nuova categoria...": "Nuova categoria...",
      "Nuova password (min 8 caratteri)": "Nuova password (min 8 caratteri)",
      "Nuovo portafoglio...": "Nuovo portafoglio...",
      "Operazione completata": "Operazione completata",
      "Origine e destinazione devono essere diversi": "Origine e destinazione devono essere diversi",
      "Pagina non trovata": "Pagina non trovata",
      "Password": "Password",
      "Password Dimenticata": "Password Dimenticata",
      "Password aggiornata": "Password aggiornata",
      "Password aggiornata con successo": "Password aggiornata con successo",
      "Password attuale": "Password attuale",
      "Password attuale non corretta": "Password attuale non corretta",
      "Password deve contenere maiuscola, minuscola e numero": "Password deve contenere maiuscola, minuscola e numero",
      "Password dimenticata?": "Password dimenticata?",
      "Password non corretta": "Password non corretta",
      "Password richiesta": "Password richiesta",
      "Password è richiesta": "Password è richiesta",
      "Periodo": "Periodo",
      "Portafogli": "Portafogli",
      "Portafogli eliminati": "Portafogli eliminati",
      "Portafoglio": "Portafoglio",
      "Questa azione non può essere annullata.": "Questa azione non può essere annullata.",
      "Registrati": "Registrati",
      "Registrati con Google": "Registrati con Google",
      "Registrazione completata con successo!": "Registrazione completata con successo!",
      "Registrazione effettuata! Controlla la tua email per confermare l'account.": "Registrazione effettuata! Controlla la tua email per confermare l'account.",
      "Registrazione in corso...": "Registrazione in corso...",
      "Report": "Report",
      "Ricordami": "Ricordami",
      "Rifiuta": "Rifiuta",
      "Ripeti la nuova password": "Ripeti la nuova password",
      "Ripeti la password": "Ripeti la password",
      "Risparmi": "Risparmi",
      "Saldo": "Saldo",
      "Salva": "Salva",
      "Salva Nuova Password": "Salva Nuova Password",
      "Salvataggio...": "Salvataggio...",
      "Scarica CSV": "Scarica CSV",
      "Scarica un file CSV con tutte le transazioni, oppure seleziona filtri (tipo, categorie, portafogli, periodo).": "Scarica un file CSV con tutte le transazioni, oppure seleziona filtri (tipo, categorie, portafogli, periodo).",
      "Scegli il file da importare": "Scegli il file da importare",
      "Scegli se eliminare tutte le transazioni o solo quelle che corrispondono ai filtri selezionati.": "Scegli se eliminare tutte le transazioni o solo quelle che corrispondono ai filtri selezionati.",
      "Scegli se esportare tutte le transazioni o solo quelle che corrispondono ai filtri selezionati.": "Scegli se esportare tutte le transazioni o solo quelle che corrispondono ai filtri selezionati.",
      "Segna letta": "Segna letta",
      "Sei sicuro di voler eliminare": "Sei sicuro di voler eliminare",
      "Sei sicuro di voler eliminare il portafoglio": "Sei sicuro di voler eliminare il portafoglio",
      "Sei sicuro di voler eliminare la categoria": "Sei sicuro di voler eliminare la categoria",
      "Sei sicuro di voler eliminare questa transazione?": "Sei sicuro di voler eliminare questa transazione?",
      "Seleziona almeno un filtro oppure scegli 'Tutto'": "Seleziona almeno un filtro oppure scegli 'Tutto'",
      "Seleziona il portafoglio di destinazione": "Seleziona il portafoglio di destinazione",
      "Seleziona la tua lingua preferita": "Seleziona la tua lingua preferita",
      "Spesa": "Spesa",
      "Spese": "Spese",
      "Spese del mese": "Spese del mese",
      "Spese ed entrate per portafoglio": "Spese ed entrate per portafoglio",
      "Tipo": "Tipo",
      "Token mancante": "Token mancante",
      "Token non valido": "Token non valido",
      "Torna al Login": "Torna al Login",
      "Torna alla pagina di accesso": "Torna alla pagina di accesso",
      "Transazione aggiornata!": "Transazione aggiornata!",
      "Transazione aggiunta!": "Transazione aggiunta!",
      "Transazione eliminata": "Transazione eliminata",
      "Transazioni": "Transazioni",
      "Transazioni eliminate": "Transazioni eliminate",
      "Trasferimenti": "Trasferimenti",
      "Trasferimento": "Trasferimento",
      "Trasferimento creato!": "Trasferimento creato!",
      "Tutte": "Tutte",
      "Tutte le transazioni associate verranno eliminate.": "Tutte le transazioni associate verranno eliminate.",
      "Tutti": "Tutti",
      "Tutti i tipi": "Tutti i tipi",
      "Tutto": "Tutto",
      "Usa il campo sopra per aggiungerne una.": "Usa il campo sopra per aggiungerne una.",
      "Usa il campo sopra per aggiungerne uno.": "Usa il campo sopra per aggiungerne uno.",
      "Usa il pulsante": "Usa il pulsante",
      "Uscite per categoria": "Uscite per categoria",
      "Utente non trovato": "Utente non trovato",
      "Utente registrato con successo": "Utente registrato con successo",
      "Vai al Login": "Vai al Login",
      "Verranno rimosse le tue categorie e le transazioni ad esse collegate.": "Verranno rimosse le tue categorie e le transazioni ad esse collegate.",
      "Verranno rimossi definitivamente il tuo account e tutti i dati ad esso collegati. Azione irreversibile.": "Verranno rimossi definitivamente il tuo account e tutti i dati ad esso collegati. Azione irreversibile.",
      "Verranno rimossi i tuoi portafogli e le transazioni ad essi collegate. Se un portafoglio è condiviso, la proprietà passa al cointestatario più anziano.": "Verranno rimossi i tuoi portafogli e le transazioni ad essi collegate. Se un portafoglio è condiviso, la proprietà passa al cointestatario più anziano.",
      "aggiornata!": "aggiornata!",
      "aggiornato!": "aggiornato!",
      "aggiunta!": "aggiunta!",
      "aggiunto!": "aggiunto!",
      "categorie create": "categorie create",
      "condiviso": "condiviso",
      "oppure con email": "oppure con email",
      "per aggiungerne una.": "per aggiungerne una.",
      "portafogli creati": "portafogli creati",
      "righe processate": "righe processate",
      "rimossa": "rimossa",
      "rimosso": "rimosso",
      "transazioni importate": "transazioni importate"
    }
  },
  en: {
    translation: {
      "(si attiverà alla registrazione)": "(will be activated upon registration)",
      "A": "To",
      "Abbiamo inviato un link sicuro all'indirizzo email.": "We have sent a secure link to the email address.",
      "Accedi": "Sign In",
      "Accedi al tuo account": "Login to your account",
      "Accedi con Google": "Sign in with Google",
      "Accesso in corso...": "Signing in...",
      "Accetta": "Accept",
      "Account": "Account",
      "Account eliminato": "Account deleted",
      "Aggiorna Password": "Update Password",
      "Aggiorna la password del tuo account": "Update your account password",
      "Aggiorna la password del tuo account.": "Update your account password.",
      "Aggiungi": "Add",
      "Aggiungi categoria": "Add category",
      "Aggiungi portafoglio": "Add wallet",
      "Al": "To",
      "Al:": "To:",
      "Andamento mensile (spese vs entrate)": "Monthly trend (expenses vs income)",
      "Annulla": "Cancel",
      "Azioni irreversibili, richiedono la password": "Irreversible actions, password required",
      "Azioni irreversibili_desc": "These actions are irreversible. Your password is required to confirm.",
      "Azzera": "Reset",
      "Azzera filtri": "Reset filters",
      "Backup e Ripristino": "Backup and Restore",
      "Benvenuto": "Welcome",
      "Cambia Password": "Change Password",
      "Cambia la lingua dell'applicazione / Change app language": "Change the application language",
      "Carica file": "Choose file",
      "Carica un file XLSX o CSV. Verranno creati automaticamente portafogli, categorie e transazioni mancanti.": "Upload an XLSX or CSV file. Missing wallets, categories and transactions will be created automatically.",
      "Caricamento categorie...": "Loading categories...",
      "Caricamento portafogli...": "Loading wallets...",
      "Caricamento sessione...": "Loading session...",
      "Caricamento...": "Loading...",
      "Carta di credito": "Credit card",
      "Categoria": "Category",
      "Categorie": "Categories",
      "Categorie eliminate": "Categories deleted",
      "Categorie per trasferimento non trovate": "Transfer categories not found",
      "Cognome": "Last Name",
      "Cognome deve avere almeno 2 caratteri": "Last name must be at least 2 characters",
      "Cognome è richiesto": "Last name is required",
      "Compila tutti i campi": "Fill in all fields",
      "Conferma Nuova Password": "Confirm New Password",
      "Conferma Password": "Confirm Password",
      "Conferma eliminazione": "Confirm deletion",
      "Conferma nuova password": "Confirm new password",
      "Conferma password è richiesta": "Confirm password is required",
      "Contanti": "Cash",
      "Conti": "Bank accounts",
      "Crea il tuo account": "Create your account",
      "Crea trasferimento": "Create transfer",
      "Crea una password sicura": "Create a secure password",
      "Credenziali non valide": "Invalid credentials",
      "Da": "From",
      "Dal": "From",
      "Dal:": "From:",
      "Dashboard": "Dashboard",
      "Descrizione": "Description",
      "Descrizione (opzionale)": "Description (optional)",
      "Elimina": "Delete",
      "Elimina Transazioni": "Delete Transactions",
      "Elimina account": "Delete account",
      "Elimina categoria": "Delete category",
      "Elimina definitivamente account e tutti i dati collegati.": "Permanently delete your account and all linked data.",
      "Elimina notifica": "Delete notification",
      "Elimina portafoglio": "Delete wallet",
      "Elimina transazione": "Delete transaction",
      "Elimina transazioni": "Delete transactions",
      "Elimina tutte le categorie": "Delete all categories",
      "Elimina tutte le categorie e le transazioni collegate.": "Delete all categories and their linked transactions.",
      "Elimina tutte le tue transazioni, oppure solo quelle che corrispondono a filtri specifici.": "Delete all your transactions, or only those matching specific filters.",
      "Elimina tutti i portafogli": "Delete all wallets",
      "Elimina tutti i portafogli (escluso Generale) e le transazioni collegate.": "Delete all wallets (except General) and their linked transactions.",
      "Eliminazione Dati": "Data Deletion",
      "Eliminazione...": "Deleting...",
      "Email": "Email",
      "Email della persona da invitare": "Email of the person to invite",
      "Email gia' registrata": "Email already registered",
      "Email non trovata": "Email not found",
      "Email è richiesta": "Email is required",
      "Entrate": "Income",
      "Entrate del mese": "Monthly income",
      "Entrate per categoria": "Income by category",
      "Errore": "Error",
      "Errore caricamento dati": "Error loading data",
      "Errore caricamento report": "Error loading report",
      "Errore durante il cambio password": "Error changing password",
      "Errore durante il login": "Error during login",
      "Errore durante il trasferimento": "Error during transfer",
      "Errore durante l'accesso con Google": "Error signing in with Google",
      "Errore durante l'aggiornamento della password. Il link potrebbe essere scaduto.": "Error updating password. The link might have expired.",
      "Errore durante l'aggiunta": "Error while adding",
      "Errore durante l'eliminazione": "Error while deleting",
      "Errore durante l'export": "Error during export",
      "Errore durante l'import": "Error during import",
      "Errore durante l'invito": "Error while inviting",
      "Errore durante la modifica": "Error while editing",
      "Errore durante la registrazione con Google": "Error during Google registration",
      "Errore durante la registrazione.": "Error during registration.",
      "Errore durante la rimozione": "Error while removing",
      "Errore modifica": "Edit error",
      "Errore nel caricamento dati": "Error loading data",
      "Errore nel caricamento dei portafogli": "Error loading wallets",
      "Errore nel caricamento delle categorie": "Error loading categories",
      "Errore nel caricamento delle notifiche": "Error loading notifications",
      "Errore trasferimento": "Transfer error",
      "Esci": "Log out",
      "Esporta CSV": "Export CSV",
      "Esporta dati": "Export data",
      "Esporta il tuo archivio o importa un backup da file": "Export your data or import a backup from a file",
      "Esporta le tue transazioni in un file CSV (tutte o filtrate), o importa un backup da file XLSX/CSV.": "Export your transactions to a CSV file (all or filtered), or import a backup from an XLSX/CSV file.",
      "Esporta transazioni": "Export transactions",
      "Esportazione...": "Exporting...",
      "Filtra": "Filter",
      "Filtri": "Filters",
      "Generale": "General",
      "Guadagni": "Income",
      "Guadagno": "Income",
      "Hai già un account?": "Already have an account?",
      "I tuoi Portafogli": "Your Wallets",
      "Import completato!": "Import completed!",
      "Importa backup": "Import backup",
      "Importazione in corso...": "Importing...",
      "Importo": "Amount",
      "Impossibile inviare l'email di recupero. Riprova più tardi.": "Unable to send recovery email. Try again later.",
      "Imposta Nuova Password": "Set New Password",
      "Impostazioni": "Settings",
      "Inserisci e conferma la tua nuova password.": "Enter and confirm your new password.",
      "Inserisci il tuo cognome": "Enter your last name",
      "Inserisci il tuo nome": "Enter your first name",
      "Inserisci l'email del tuo account": "Enter your account email",
      "Inserisci la password": "Enter your password",
      "Inserisci la password per confermare": "Enter your password to confirm",
      "Inserisci la tua email": "Enter your email",
      "Inserisci la tua email. Ti invieremo un link sicuro per reimpostarla.": "Enter your email. We will send you a secure link to reset it.",
      "Inserisci un indirizzo email valido": "Enter a valid email address",
      "Invia Link di Recupero": "Send Recovery Link",
      "Invia invito": "Send invitation",
      "Invio in corso...": "Sending...",
      "Invita a": "Invite to",
      "Invito accettato!": "Invitation accepted!",
      "Invito creato per": "Invitation created for",
      "Invito inviato a": "Invitation sent to",
      "Invito rifiutato": "Invitation declined",
      "La nuova password deve avere almeno 8 caratteri": "The new password must be at least 8 characters",
      "La password deve avere almeno 8 caratteri": "Password must be at least 8 characters",
      "La tua Email": "Your Email",
      "La tua password è stata aggiornata con successo!": "Your password has been successfully updated!",
      "Le password non coincidono": "Passwords do not match",
      "Le tue Categorie": "Your Categories",
      "Lingua": "Language",
      "Login effettuato con successo!": "Login successful!",
      "Mese": "Month",
      "Minimo 8 caratteri": "Minimum 8 characters",
      "Modifica": "Edit",
      "Mostra conferma password": "Show confirm password",
      "Mostra password": "Show password",
      "Nascondi conferma password": "Hide confirm password",
      "Nascondi password": "Hide password",
      "Nessun dato": "No data",
      "Nessun dato per il periodo.": "No data for this period.",
      "Nessun portafoglio": "No wallets",
      "Nessun portafoglio creato.": "No wallet created.",
      "Nessuna categoria": "No categories",
      "Nessuna categoria creata.": "No category created.",
      "Nessuna notifica.": "No notifications.",
      "Nessuna transazione a": "No transactions in",
      "Nessuna transazione.": "No transactions.",
      "Nome": "First Name",
      "Nome deve avere almeno 2 caratteri": "First name must be at least 2 characters",
      "Nome è richiesto": "First name is required",
      "Non hai un account?": "Don't have an account?",
      "Notifiche": "Notifications",
      "Nuova Password": "New Password",
      "Nuova Transazione": "New Transaction",
      "Nuova categoria...": "New category...",
      "Nuova password (min 8 caratteri)": "New password (min 8 characters)",
      "Nuovo portafoglio...": "New wallet...",
      "Operazione completata": "Operation completed",
      "Origine e destinazione devono essere diversi": "Source and destination must be different",
      "Pagina non trovata": "Page not found",
      "Password": "Password",
      "Password Dimenticata": "Forgot Password",
      "Password aggiornata": "Password updated",
      "Password aggiornata con successo": "Password updated successfully",
      "Password attuale": "Current password",
      "Password attuale non corretta": "Current password is incorrect",
      "Password deve contenere maiuscola, minuscola e numero": "Password must contain uppercase, lowercase and a number",
      "Password dimenticata?": "Forgot Password?",
      "Password non corretta": "Incorrect password",
      "Password richiesta": "Password is required",
      "Password è richiesta": "Password is required",
      "Periodo": "Period",
      "Portafogli": "Wallets",
      "Portafogli eliminati": "Wallets deleted",
      "Portafoglio": "Wallet",
      "Questa azione non può essere annullata.": "This action cannot be undone.",
      "Registrati": "Sign up",
      "Registrati con Google": "Sign up with Google",
      "Registrazione completata con successo!": "Registration successful!",
      "Registrazione effettuata! Controlla la tua email per confermare l'account.": "Registration successful! Check your email to confirm your account.",
      "Registrazione in corso...": "Signing up...",
      "Report": "Reports",
      "Ricordami": "Remember me",
      "Rifiuta": "Decline",
      "Ripeti la nuova password": "Repeat the new password",
      "Ripeti la password": "Repeat password",
      "Risparmi": "Savings",
      "Saldo": "Balance",
      "Salva": "Save",
      "Salva Nuova Password": "Save New Password",
      "Salvataggio...": "Saving...",
      "Scarica CSV": "Download CSV",
      "Scarica un file CSV con tutte le transazioni, oppure seleziona filtri (tipo, categorie, portafogli, periodo).": "Download a CSV file with all transactions, or select filters (type, categories, wallets, period).",
      "Scegli il file da importare": "Choose the file to import",
      "Scegli se eliminare tutte le transazioni o solo quelle che corrispondono ai filtri selezionati.": "Choose whether to delete all transactions or only those matching the selected filters.",
      "Scegli se esportare tutte le transazioni o solo quelle che corrispondono ai filtri selezionati.": "Choose whether to export all transactions or only those matching the selected filters.",
      "Segna letta": "Mark as read",
      "Sei sicuro di voler eliminare": "Are you sure you want to delete",
      "Sei sicuro di voler eliminare il portafoglio": "Are you sure you want to delete the wallet",
      "Sei sicuro di voler eliminare la categoria": "Are you sure you want to delete the category",
      "Sei sicuro di voler eliminare questa transazione?": "Are you sure you want to delete this transaction?",
      "Seleziona almeno un filtro oppure scegli 'Tutto'": "Select at least one filter or choose 'All'",
      "Seleziona il portafoglio di destinazione": "Select the destination wallet",
      "Seleziona la tua lingua preferita": "Select your preferred language",
      "Spesa": "Expense",
      "Spese": "Expenses",
      "Spese del mese": "Monthly expenses",
      "Spese ed entrate per portafoglio": "Expenses and income by wallet",
      "Tipo": "Type",
      "Token mancante": "Missing token",
      "Token non valido": "Invalid token",
      "Torna al Login": "Back to Login",
      "Torna alla pagina di accesso": "Back to login page",
      "Transazione aggiornata!": "Transaction updated!",
      "Transazione aggiunta!": "Transaction added!",
      "Transazione eliminata": "Transaction deleted",
      "Transazioni": "Transactions",
      "Transazioni eliminate": "Transactions deleted",
      "Trasferimenti": "Transfers",
      "Trasferimento": "Transfer",
      "Trasferimento creato!": "Transfer created!",
      "Tutte": "All",
      "Tutte le transazioni associate verranno eliminate.": "All linked transactions will be deleted.",
      "Tutti": "All",
      "Tutti i tipi": "All types",
      "Tutto": "All",
      "Usa il campo sopra per aggiungerne una.": "Use the field above to add one.",
      "Usa il campo sopra per aggiungerne uno.": "Use the field above to add one.",
      "Usa il pulsante": "Use the button",
      "Uscite per categoria": "Expenses by category",
      "Utente non trovato": "User not found",
      "Utente registrato con successo": "User registered successfully",
      "Vai al Login": "Go to Login",
      "Verranno rimosse le tue categorie e le transazioni ad esse collegate.": "Your categories and their linked transactions will be removed.",
      "Verranno rimossi definitivamente il tuo account e tutti i dati ad esso collegati. Azione irreversibile.": "Your account and all linked data will be permanently removed. This action is irreversible.",
      "Verranno rimossi i tuoi portafogli e le transazioni ad essi collegate. Se un portafoglio è condiviso, la proprietà passa al cointestatario più anziano.": "Your wallets and their linked transactions will be removed. If a wallet is shared, ownership passes to the longest-standing co-owner.",
      "aggiornata!": "updated!",
      "aggiornato!": "updated!",
      "aggiunta!": "added!",
      "aggiunto!": "added!",
      "categorie create": "categories created",
      "condiviso": "shared",
      "oppure con email": "or with email",
      "per aggiungerne una.": "to add one.",
      "portafogli creati": "wallets created",
      "righe processate": "rows processed",
      "rimossa": "removed",
      "rimosso": "removed",
      "transazioni importate": "transactions imported"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'it', // lingua di default
    supportedLngs: ['it', 'en'],
    nonExplicitSupportedLngs: true, // 'en-US' -> 'en'
    // Le chiavi sono frasi: disattiva i separatori di namespace/chiave annidata
    keySeparator: false,
    nsSeparator: false,
    interpolation: {
      escapeValue: false // non serve per React
    }
  });

// Mantiene l'attributo lang del documento allineato alla lingua attiva
const syncHtmlLang = () => {
  document.documentElement.lang = i18n.resolvedLanguage || 'it';
};
i18n.on('languageChanged', syncHtmlLang);
syncHtmlLang();

// Locale per formattazione di numeri e date ('it-IT' / 'en-US')
export const getLocale = () => (i18n.resolvedLanguage === 'en' ? 'en-US' : 'it-IT');

// Traduce i messaggi di errore/successo restituiti dal backend (in italiano);
// se non sono stringhe o non hanno una traduzione, li restituisce invariati.
export const trd = (msg) => (typeof msg === 'string' ? i18n.t(msg) : msg);

export default i18n;
